import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpValueTypeFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";
// @ts-ignore noUnusedLocals
import { ExpValueTypeEnumValueFactory } from "./ExpValueTypeEnumValue";

/**
 * A dynamic enum of primitive types of values (not object types). Types are used to find ExpOperators for values, and values for operands.
 * @export
 * @interface ExpValueType
 */

export class ExpValueTypeFactory {}
_ExpValueTypeFactory = ExpValueTypeFactory;
_defineProperty(ExpValueTypeFactory, "FromJSON", function (json) {
  return _ExpValueTypeFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpValueTypeFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'label': json['label'],
    'description': json['description'],
    'enumValues': json['enumValues'] === null || json['enumValues'] === undefined ? json['enumValues'] : json['enumValues'].map(ExpValueTypeEnumValueFactory.FromJSON),
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData']),
    'numDecimalPlaces': json['numDecimalPlaces'],
    'integrationConfiguration': json['integrationConfiguration'] === null || json['integrationConfiguration'] === undefined ? json['integrationConfiguration'] : json['integrationConfiguration']
  };
});
_defineProperty(ExpValueTypeFactory, "ToJSON", function (value) {
  return _ExpValueTypeFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpValueTypeFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'label': value.label,
    'description': value.description,
    'enumValues': value.enumValues === undefined ? undefined : value.enumValues.map(ExpValueTypeEnumValueFactory.ToJSON),
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData),
    'numDecimalPlaces': value.numDecimalPlaces,
    'integrationConfiguration': value.integrationConfiguration
  };
});
//# sourceMappingURL=ExpValueType.js.map
